import { contentWrapperMaxWidth } from '../../content/components/constants';

export const maxNavWidth = contentWrapperMaxWidth;
export const navDesktopHeight = 6.0;
export const navMobileHeight = 5.2;
